import styled from '@emotion/styled/macro'
import { themeColor } from 'mixins'
import { CommandBar, ICommandBarProps } from 'office-ui-fabric-react'
import * as React from 'react'

const StyledCommandBar = styled(CommandBar)`
  border-bottom: 1px solid ${themeColor('neutralLight')};
`

export type AppCommandBarProps = ICommandBarProps & {
  hideWhenEmpty?: boolean
}

export const AppCommandBar: React.FunctionComponent<AppCommandBarProps> = ({
  hideWhenEmpty,
  ...props
}) => {
  if (
    hideWhenEmpty! &&
    [...props.items, ...(props.farItems || [])].length === 0
  ) {
    return null
  }

  return <StyledCommandBar {...props} />
}
AppCommandBar.displayName = 'AppCommandBar'

export default AppCommandBar
